import AppEditorMixin from "@/protected/mixins/AppEditorMixin";
import service from "./PersonService";
import PersonForm from "./PersonForm";

export default {
  mixins: [AppEditorMixin],

  created() {
    this.tabs = [
      {
        component: PersonForm,
        title: () => this.$t("person.tabs.main"),
        icon: "user"
      }
    ];
  },

  methods: {
    getService() {
      return service;
    }
  }
};
